// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"d567773a","633":"ff3a0de8","861":"0fb4fe0a","920":"55cbf23e","992":"88730aa1"}[chunkId] + ".chunk.css";
};